import React from 'react';
import { Button } from '@mui/material';
import { SELECT_BUTTON } from '../constants/TranslationConstants';

interface SelectButtonProps {
  onSelect: () => void;
  disabled?: boolean;
}

const SelectButton = ({ onSelect, disabled = false }: SelectButtonProps) => {
  return (
    <Button
      variant="contained"
      onClick={onSelect}
      disabled={disabled}
      size="small"
      sx={{
        fontSize: "10px",
        background: disabled ? "#9e9e9e" : "#006684",
        height: "30px",
        color: "#FFFFFF",
        cursor: disabled ? "not-allowed" : "pointer",
        textTransform: "capitalize",
        fontWeight: "600",
        '&:hover': {
          backgroundColor: disabled ? "#9e9e9e" : "#005a70",
        }
      }}
    >
      {SELECT_BUTTON}
    </Button>
  );
};

export default SelectButton;